//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Viewer from "./components/Viewer.vue";
import * as CommandUI from "./components/commands";
import * as Menu from "./components/menu";
import Node from "./js/feature";
const debug = require("debug")("App");

export default {
  name: "app",
  components: {
    Viewer,
    ...CommandUI,
    ...Menu
  },
  data() {
    return {
      currentCommand: "",
      expanded: [],
      preview: [],
      scene: new Node("Root"),
      selectedFeatures: [],
      ticked: [],
      tempFeature: undefined
    };
  },
  methods: {
    execute(csg) {
      var primaryFeature = this.selectedFeatures[0];
      this.$set(primaryFeature, "geometry", csg);

      this.selectedFeatures.slice(1).forEach(feature => {
        primaryFeature.addChild(feature);
        var index = this.scene.children.indexOf(feature);
        if (index > -1) {
          this.scene.children.splice(index, 1);
          console.log("Removed", feature);
        }
      });

      this.selectedFeatures.length = 0;
      this.setCommand("");
    },
    storeFeatureNode(feature) {
      this.scene.addChild(feature);
      this.setCommand("");
      this.$set(this.preview, "length", 0);
    },
    updateFeatureNode(csg) {
      var primaryFeature = this.selectedFeatures[0];
      this.$set(primaryFeature, "geometry", csg);
      this.setCommand("");
    },
    previewFeature(feature) {
      this.preview = [feature];
    },
    handleTicked() {
      this.$nextTick(function() {
        this.selectedFeatures = this.$refs.tree.getTickedNodes();
      });
    },
    setCommand(command) {
      this.currentCommand = command;
      this.$set(this.preview, 0, undefined);
      this.preview.length = 0;
    }
  }
};
